<template>
  <div class="asc-tooltip">
    <template v-if="isValidTooltip">
      <v-tooltip
        :bottom="bottom"
        :right="right"
        :left="left"
        :top="top"
        :color="getColor"
        :content-class="'asc-tooltip-detached ' + getContentClass"
        :nudge-bottom="nudgeBottom"
        open-delay="500"
        :max-width="getWidth"
        :is-icon-tooltip="isIconTooltip"
        :attach="attach"
      >
        <template #activator="{ on }">
          <div class="asc-tooltip--container" v-on="on"><slot></slot></div>
        </template>
        <span>{{ getTooltip }}</span>
      </v-tooltip>
    </template>
    <template v-if="!isValidTooltip">
      <slot></slot>
    </template>
  </div>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscTooltip',

  props: {
    attach: {
      type: [String, Boolean],
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    right: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: 'auto',
    },
    isIconTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipLength: {
      type: Number,
      default: 27,
    },
    nudgeBottom: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    isValidTooltip() {
      return this.tooltip.length > 0
    },

    // eslint-disable-next-line vue/return-in-computed-property
    getContentClass() {
      if (this.right) {
        return 'asc-tooltip--arrow-left'
      }
      if (this.left) {
        return 'asc-tooltip--arrow-right'
      }
      if (this.top) {
        return 'asc-tooltip--arrow-bottom'
      }
      if (this.bottom) {
        return this.isIconTooltip
          ? 'asc-tooltip--arrow-top asc-icon-tooltip'
          : 'asc-tooltip--arrow-top'
      }
      return ''
    },

    getColor() {
      return variables.gray1000
    },

    getWidth() {
      return parseInt(this.maxWidth)
    },

    getTooltip() {
      if (this.tooltipLength === 0) {
        return this.tooltip
      }
      const maxLength = this.tooltipLength - 3
      if (
        this.tooltip.length > this.tooltipLength &&
        this.maxWidth === 'auto'
      ) {
        return this.tooltip.substring(0, maxLength) + '...'
      }
      return this.tooltip
    },
  },
}
</script>

<style lang="scss">
.asc-tooltip-detached {
  $transparent-border: 8px solid transparent;
  $color-border: 8px solid $gray-1000;
  span {
    white-space: pre-line;
  }
  &.v-tooltip__content {
    &.menuable__content__active {
      font-size: $font-size-sm !important;
      line-height: 18px !important;
      margin-top: 0 !important;
      padding: 5px 8px;

      &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        clear: both;
      }

      &.asc-tooltip--arrow-left {
        margin-left: 4px;

        &::before {
          left: -8px;
          top: 7px;
          border-top: $transparent-border;
          border-bottom: $transparent-border;
          border-right: $color-border;
        }
      }

      &.asc-tooltip--arrow-right {
        margin-right: 4px;

        &::before {
          right: -8px;
          top: 7px;
          border-top: $transparent-border;
          border-bottom: $transparent-border;
          border-left: $color-border;
        }
      }

      &.asc-tooltip--arrow-bottom {
        &::before {
          left: 47.7%;
          top: 100%;
          transform: translateY(0);
          border-left: $transparent-border;
          border-right: $transparent-border;
          border-top: $color-border;
        }
      }

      &.asc-tooltip--arrow-top {
        margin-top: -5px !important;

        &::before {
          left: 47.7%;
          top: -8px;
          border-left: $transparent-border;
          border-right: $transparent-border;
          border-bottom: $color-border;
        }
      }
    }
  }
}
</style>
